import { isMockEnabled } from "@/lib/mock-flags";
import { sseClient } from "./sse-client";
import { mockNotificationsClient } from "./sse-mock";
import type { NotificationsClient } from "./types";

/** Cliente ativo escolhido pela flag VITE_MOCK_NOTIFICATIONS (ou VITE_MOCK_AGENCY). */
export function getNotificationsClient(): NotificationsClient {
  return isMockEnabled("notifications") ? mockNotificationsClient : sseClient;
}

export type { NotificationsClient } from "./types";
